module.exports = __webpack_public_path__ + "static/jasmine-zoom-d10f325880fcbe8341526c69d95dcbf9.jpg";